import { Encoder } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { Move } from '../../jscaip/Move';
import { DiamPiece } from './DiamPiece';
export class DiamMove extends Move {
    isDrop() {
        return this instanceof DiamMoveDrop;
    }
    isShift() {
        return this instanceof DiamMoveShift;
    }
}
export class DiamMoveDrop extends DiamMove {
    target;
    piece;
    static encoder = Encoder.tuple([Encoder.identity(), DiamPiece.encoder], (drop) => [drop.target, drop.piece], (fields) => new DiamMoveDrop(fields[0], fields[1]));
    constructor(target, piece) {
        super();
        this.target = target;
        this.piece = piece;
        if (piece === DiamPiece.EMPTY) {
            throw new Error('Cannot drop an empty piece');
        }
    }
    getTarget() {
        return this.target;
    }
    equals(other) {
        if (other instanceof DiamMoveDrop) {
            if (this.target !== other.target)
                return false;
            if (this.piece !== other.piece)
                return false;
            return true;
        }
        return false;
    }
    toString() {
        return `DiamMoveDrop(${this.target}, ${this.piece})`;
    }
}
export class DiamMoveShift extends DiamMove {
    start;
    moveDirection;
    static encoder = Encoder.tuple([Coord.encoder, Encoder.identity()], (shift) => [shift.start, shift.moveDirection === 'clockwise'], (fields) => new DiamMoveShift(fields[0], fields[1] ? 'clockwise' : 'counterclockwise'));
    static ofRepresentation(representationStart, moveDirection) {
        // In the representation, the y axis is reverted, so 3 - y gives the real y on board
        return new DiamMoveShift(new Coord(representationStart.x, 3 - representationStart.y), moveDirection);
    }
    constructor(start, moveDirection) {
        super();
        this.start = start;
        this.moveDirection = moveDirection;
    }
    getTarget() {
        if (this.moveDirection === 'clockwise') {
            return (this.start.x + 1) % 8;
        }
        else {
            return (this.start.x + 7) % 8;
        }
    }
    equals(other) {
        if (other instanceof DiamMoveShift) {
            if (this.start.equals(other.start) === false)
                return false;
            if (this.moveDirection !== other.moveDirection)
                return false;
            return true;
        }
        else {
            return false;
        }
    }
    toString() {
        return `DiamMoveShift(${this.start}, ${this.moveDirection})`;
    }
}
export const DiamMoveEncoder = Encoder.disjunction([
    (move) => move.isDrop(),
    (move) => move.isShift(),
], [DiamMoveDrop.encoder, DiamMoveShift.encoder]);
